import { info } from 'autoprefixer';
import { $qs, $qsa } from '../../../src/js/utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function infoScroller() {
  if($qs('[data-name="info-scroller"]')) {
    const scrollerBackground = $qs('[data-name="info-scroller-background"]');
    
    const timeline = gsap.timeline();

    timeline.to(scrollerBackground, {
        y:0,
        ease: "none",        
      });
        
    
    ScrollTrigger.create({
      animation: timeline,
      trigger: scrollerBackground,
      pin: true,
      // end: "bottom top",
      // markers: true,
      scrub: true,
      // start: "top top",
      // end: () => `+=${pinAmount}`,
      invalidateOnRefresh: true,
      // markers: true,
    })

    ScrollTrigger.sort();
  }
}

export default infoScroller;